import { CalendarIcon } from "@/assets";
import { FormControl, IconButton, Typography } from "@mui/material";
import { useField, useFormikContext } from "formik";
import { useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { toast } from "react-toastify";
import StyleAsarInputComponent, {
  styleLabel,
  styleLabelWithError,
} from "./StyleAsaInputCompnent";

function AsarDatePicker({ label, placeholder, name }) {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [showDatePicker, setShowDatePicker] = useState();

  const formatDateString = (value) => {
    // حذف تمام غیراعداد
    const numbers = value.replace(/\D/g, "");

    if (numbers.length === 0) return "";

    // محدود کردن طول به 8 رقم (سال 4 رقم، ماه 2 رقم، روز 2 رقم)
    const limitedNumbers = numbers.slice(0, 8);

    // فرمت کردن با اسلش
    if (limitedNumbers.length <= 4) {
      return limitedNumbers;
    } else if (limitedNumbers.length <= 6) {
      return `${limitedNumbers.slice(0, 4)}/${limitedNumbers.slice(4)}`;
    } else {
      return `${limitedNumbers.slice(0, 4)}/${limitedNumbers.slice(
        4,
        6,
      )}/${limitedNumbers.slice(6, 8)}`;
    }
  };

  const handleBirthDateChange = (e) => {
    let value = e.target.value;

    // فرمت کردن رشته تاریخ
    const formattedValue = formatDateString(value);

    // فقط اگر فرمت کامل شد (8 رقم) اعتبارسنجی کن
    const numbers = formattedValue.replace(/\D/g, "");
    if (numbers.length === 8) {
      const year = parseInt(numbers.slice(0, 4), 10);
      const month = parseInt(numbers.slice(4, 6), 10);
      const day = parseInt(numbers.slice(6, 8), 10);

      // اعتبارسنجی
      if (year < 1300 || year > 1500) {
        toast.error("سال باید بین 1300 و 1500 باشد");
        return;
      }
      if (month < 1 || month > 12) {
        toast.error("ماه باید بین 1 و 12 باشد");
        return;
      }

      // تبدیل به DateObject برای یکپارچگی با DatePicker
      const dateObj = new DateObject({
        year,
        month,
        day,
        calendar: persian,
      });

      setFieldValue(name, dateObj);
    } else {
      setFieldValue(name, formattedValue);
    }
  };

  return (
    <FormControl
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
      fullWidth
      variant="standard"
      error={meta.error !== undefined}
    >
      <Typography
        color={"text.primary"}
        sx={meta.error !== undefined ? styleLabelWithError : styleLabel}
      >
        {label}
      </Typography>

      <DatePicker
        notRange
        render={(_, openCalendar) => {
          const displayValue =
            field.value instanceof DateObject
              ? field.value.format("YYYY/MM/DD")
              : field.value || "";

          return (
            <StyleAsarInputComponent
              onChange={handleBirthDateChange}
              value={displayValue}
              placeholder={placeholder}
              endAdornment={
                <IconButton onClick={openCalendar}>
                  <CalendarIcon />
                </IconButton>
              }
            />
          );
        }}
        calendar={persian}
        locale={persian_fa}
        value={field?.value}
        onChange={(d) => {
          if (d === null) return;
          setFieldValue(name, d);
        }}
        show={showDatePicker}
        setShow={setShowDatePicker}
      />
      {meta.error && (
        <Typography variant="caption" color="error" sx={{ ml: "4px" }}>
          {meta.error}
        </Typography>
      )}
    </FormControl>
  );
}

export default AsarDatePicker;
